import React, { Component, useEffect } from "react";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";
import { Button } from "mdbreact";
import { useState } from "react";
import axios from 'axios';
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from "@material-ui/core/Tooltip";
import { ExitToApp } from "@material-ui/icons";



const SoilMoistureChart = (props) =>
{
    const {tower_id} = props;
    
    const [options , setOptions] = useState({
                chart: {
                  id: "basic-bar",
                  background : ' #FFFFFF',
                },
                xaxis: {
                  categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
              });
    const [series , setSeries] = useState(null);

    useEffect( () =>
    {
      var h = window.innerHeight;
      var w = window.innerWidth;
      const values15 = Array();
      const values30 = Array();
      const values45 = Array();
      const values60 = Array();
      const values75 = Array();
      const values90 = Array();
      const dates = Array();
      
      axios.get('https://bhuvan.nrsc.gov.in/nhpds/fetch-nhp-soil-graph/'+tower_id+'/all').then((response) => {
        
      if(response)
      {
              var size = response.data.length;
              var fromDate;
              var toDate;
              if(size > 1)
              {
                fromDate = response.data[size-1].date;
                toDate = response.data[0].date;
              }
              else
              {
                fromDate = '-';
                toDate = '-';
              }
              for(var i = size-1;i>=0;i--)
              {
                  values15.push(response.data[i].soil_vwc_15_avg);
                  values30.push(response.data[i].soil_vwc_30_avg);
                  values45.push(response.data[i].soil_vwc_45_avg);
                  values60.push(response.data[i].soil_vwc_60_avg);
                  values75.push(response.data[i].soil_vwc_75_avg);
                  values90.push(response.data[i].soil_vwc_90_avg);

                  dates.push(response.data[i].date);
              }
              setSeries([
                {
                  name: "SM 0 - 15 cm",
                  data: values15,
                },
                {
                  name: "SM 16 - 30 cm",
                  data: values30,
                },
                {
                  name: "SM 30 - 45 cm",
                  data: values45,
                },
                {
                  name: "SM 46 - 60 cm",
                  data: values60,
                },
                {
                  name: "SM 61 - 75 cm",
                  data: values75,
                },
                {
                  name: "SM 76 - 90 cm",
                  data: values90,
                }
              ]);

              setOptions(
                {
                  chart: {
                    height: 350,
                    type: 'line',
                    background : ' #FFFFFF',
                    zoom: {
                      enabled: false
                    },
                    toolbar:{
                      show:false
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'straight'
                  },
                  title: {
                    text: 'Soil Moisture Data for all ranges from ' + fromDate + ' to ' + toDate,
                    align: 'left',
                  },
                  xaxis: {
                    categories: dates,
                    tickAmount:6,
                    
                    title: {
                      text: 'Dates',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                          
                          fontSize: '12px',
                          fontFamily: 'Helvetica, Arial, sans-serif',
                          fontWeight: 600,
                          cssClass: 'apexcharts-yaxis-title',
                      },
                    },
                  },
                  yaxis: {
                    
                    title: {
                      text: 'SM Value',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                          
                          fontSize: '12px',
                          fontFamily: 'Helvetica, Arial, sans-serif',
                          fontWeight: 600,
                          cssClass: 'apexcharts-yaxis-title',
                      },
                      axisTicks: {
                        show: true,
                        borderType: 'solid',
        
                        width: 6,
                        offsetX: 0,
                        offsetY: 0
                      },
                    },
                  }
                }
              );
      }
      
        });
        
    } ,[tower_id]);

         

    const handleDataReload = (ev) =>{
      const values15 = Array();
      const values30 = Array();
      const values45 = Array();
      const values60 = Array();
      const values75 = Array();
      const values90 = Array();
      const dates = Array();
      const smValue = '0 - 15 cm';
      axios.get('https://bhuvan.nrsc.gov.in/nhpds/fetch-nhp-soil-graph/'+tower_id+'/all').then((response) => {
      if(response.data.length > 1)
      {
              var size = response.data.length;
              const fromDate = response.data[size-1].date;
              const toDate = response.data[0].date;
              for(var i = size-1;i>=0;i--)
              {
                  values15.push(response.data[i].soil_vwc_15_avg);
                  values30.push(response.data[i].soil_vwc_30_avg);
                  values45.push(response.data[i].soil_vwc_45_avg);
                  values60.push(response.data[i].soil_vwc_60_avg);
                  values75.push(response.data[i].soil_vwc_75_avg);
                  values90.push(response.data[i].soil_vwc_90_avg);

                  dates.push(response.data[i].date);
              }
              setSeries([
                {
                  name: "SM 0 - 15 cm",
                  data: values15,
                },
                {
                  name: "SM 16 - 30 cm",
                  data: values30,
                },
                {
                  name: "SM 30 - 45 cm",
                  data: values45,
                },
                {
                  name: "SM 46 - 60 cm",
                  data: values60,
                },
                {
                  name: "SM 61 - 75 cm",
                  data: values75,
                },
                {
                  name: "SM 76 - 90 cm",
                  data: values90,
                }
              ]);

              setOptions(
                {
                  chart: {
                    height: 350,
                    type: 'line',
                    background : ' #FFFFFF',
                    zoom: {
                      enabled: false
                    },
                    toolbar:{
                      show:false
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'straight'
                  },
                  title: {
                    text: 'Soil Moisture Data for all ranges from ' + fromDate + ' to ' + toDate,
                    align: 'left',
                  },
                  xaxis: {
                    categories: dates,
                    tickAmount:6,
                    
                    title: {
                      text: 'Dates',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                          
                          fontSize: '12px',
                          fontFamily: 'Helvetica, Arial, sans-serif',
                          fontWeight: 600,
                          cssClass: 'apexcharts-yaxis-title',
                      },
                    },
                  },
                  yaxis: {
                    
                    title: {
                      text: 'SM Value',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                          
                          fontSize: '12px',
                          fontFamily: 'Helvetica, Arial, sans-serif',
                          fontWeight: 600,
                          cssClass: 'apexcharts-yaxis-title',
                      },
                      axisTicks: {
                        show: true,
                        borderType: 'solid',
        
                        width: 6,
                        offsetX: 0,
                        offsetY: 0
                      },
                    },
                  }
                }
              );
      }

    });
  }
    const handleDataChange = (ev) =>{
        const id = ev.target.id;
        const values = Array();
        const dates = Array();
        var smValue;

        if(id == '15')
        {
          document.getElementById("15").style.backgroundColor = 'red';
          smValue = '0 - 15 cm';
        }
        else if(id == '30')
        {
          smValue = '16 - 30 cm';
        }
        else if(id == '45')
        {
          smValue = '31 - 45 cm';
        }
        else if(id == '60')
        {
          smValue = '46 - 60 cm';
        }
        else if(id == '75')
        {
          smValue = '61 - 75 cm';
        }
        else if(id == '90')
        {
          smValue = '75 - 90 cm';
        }
        axios.get('https://bhuvan.nrsc.gov.in/nhpds/fetch-nhp-soil-graph/'+tower_id+'/'+id).then((response) => {

              if(response.data.length > 1)
              {
                  var size = response.data.length;
                  const fromDate = response.data[size-1].date;
                  const toDate = response.data[0].date;
                  for(var i = size-1;i>=0;i--)
                  {
                      values.push(response.data[i].value);
                      dates.push(response.data[i].date);
                  }
                  setSeries([
                    {
                      name: "SM Value",
                      data: values
                    }
                  ]);
    
                  setOptions(
                    {
                      xaxis: {
                        categories: dates,
                        tickAmount:6,
                        
                        
                      },
                      title: {
                        text: 'Soil Moisture Data for ' + smValue + ' from ' + fromDate + ' to ' + toDate,
                        align: 'left',
                        
                      },
                    }
                  );
              }
        });

    }
    return (
        <>
      {(series != null)?
      <>
      <div style = {{backgroundColor:'#fff'}}>
            <ReactApexChart
              options={options}
              series={series}
              
              type="line"
              width={window.innerWidth * 0.3}
            />
      <div class="d-flex " style = {{justifyContent : "space-around"}}>
        <div>
      <div style={{ alignItems:'center',justifyContent : 'center',display:'flex'}}>
        <Tooltip title = 'Fetch graph for SM : 0 - 15 cm'><Button id = "15" onClick = {handleDataChange}>SM: 0 - 15 cm</Button></Tooltip>
        <Tooltip title = 'Fetch graph for SM : 16 - 30 cm'><Button id = "30" onClick = {handleDataChange}>SM: 16 - 30 cm</Button></Tooltip>
        <Tooltip title = 'Fetch graph for SM : 31 - 45 cm'><Button id = "45" onClick = {handleDataChange}>SM: 31 - 45 cm</Button></Tooltip>
      </div>
      <div style={{alignItems:'center',justifyContent : 'center',display:'flex'}}>
        <Tooltip title = 'Fetch graph for SM : 46 - 60 cm'><Button id = "60" onClick = {handleDataChange}>SM: 46 - 60 cm</Button></Tooltip>
        <Tooltip title = 'Fetch graph for SM : 61 - 75 cm'><Button id = "75" onClick = {handleDataChange}>SM: 61 - 75 cm</Button></Tooltip>
        <Tooltip title = 'Fetch graph for SM : 76 - 90 cm'><Button id = "90" onClick = {handleDataChange}>SM: 76 - 90 cm</Button></Tooltip>
      </div>
      </div>
      <div>
        <Tooltip title = 'Fetch graph for all the vlaues'>
          <Button id = 'reload' onClick = {handleDataReload}>
            <RefreshIcon></RefreshIcon> 
          </Button>
        </Tooltip>
      </div>
      </div> 
      </div>
      </>:null}
      </>
    );
}

export default SoilMoistureChart;

/*
class ApexChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    
      series: [{
          name: "Desktops",
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
      }],
      options: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Product Trends by Month',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        }
      },
    
    
    };
  }



  render() {
    return (
      

<div id="chart">
<ReactApexChart options={this.state.options} series={this.state.series} type="line" height={350} />
</div>*/